import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ShowProjectPage } from '@/projects/pages/show';
import { getProjectQueryOptions } from '@/projects/queries';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/projects/$projectId')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  loader: ({ context: { queryClient }, params: { projectId } }) => {
    const parsedProjectId = parseInt(projectId);
    return queryClient.ensureQueryData(getProjectQueryOptions(parsedProjectId));
  },
  component: ShowProjectRoute
});

export function ShowProjectRoute() {
  const projectId = Route.useParams().projectId;
  const parsedProjectId = parseInt(projectId);
  const { data: project } = useSuspenseQuery(getProjectQueryOptions(parsedProjectId));

  return (
    <ShowProjectPage projectId={parsedProjectId} project={project} />
  );
}
